import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Returns { active, joined, popular, loading, showAll, setShowAll, filterParam }
 * so any list page can filter by the user's active community.
 */
export function useCommunityFilter() {
  const { user } = useAuth();
  const [state, setState] = useState({ active: null, joined: [], popular: [] });
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/neighborhoods");
        if (!cancelled) setState({
          active: data.active_neighborhood,
          joined: data.neighborhoods || [],
          popular: data.popular || [],
        });
      } catch { /* silent */ }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, [user, user?.active_neighborhood, user?.neighborhood]);

  const filterParam = showAll || !state.active ? null : state.active;

  return {
    ...state,
    loading,
    showAll,
    setShowAll,
    filterParam,
  };
}
